import { Button, IconButton, Typography, Paper, Box } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { useStore } from 'effector-react'
import $auth from '../../Auth/store'
import { BlockTitle } from '../../components/UI/BlockTitle/BlockTitle'
import { Link } from 'react-router-dom'

export default function Settings() {
  const accessFlags = useStore($auth).accessFlags.paidServices.settings

  return (
    <Paper sx={{ padding: '1rem', borderRadius: '1rem', mt: 3 }} elevation={0}>
      <Box display="flex" flexDirection="column" gap={3}>
        <BlockTitle backUrl="/" label="Настройки" />
        {accessFlags?.departments && <Link to="/departments">Отделы</Link>}
        {accessFlags?.taskTypes && (
          <Link to="/responsible-for-stages">Ответственные за стадии</Link>
        )}
        {accessFlags?.rbac && <Link to="/access-rights">Права доступа</Link>}
        {accessFlags?.replacements && <Link to="/replacements">Замещения</Link>}
      </Box>
    </Paper>
  )
}
